exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form .col-md-3[data-v-20b8a2fb]{width:40%}.table[data-v-20b8a2fb]{width:100%;max-width:100%;margin-bottom:1rem;background-color:transparent}.table-responsive[data-v-20b8a2fb]{width:auto;display:block;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20b8a2fb","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/company/StockReturn.vue
// module id = 663
// module chunks = 27